<template>
    <div class="col-12 nopads pb-4">
        <div v-if="!loading && (!results || results.length < 1)" class="col-12 text-center">
            {{ $t('campaign.no_subscriptions') }}
        </div>

        <div v-else>
            <!-- Desktop layout -->
            <table class="table table-striped desktop-view">
                <thead>
                    <tr>
                        <th>{{ $t('campaign.campaign') }}</th>
                        <th>Määrä</th>
                        <th>Seuraava maksupäivä</th>
                        <th>Status</th>
                        <th>Toiminnot</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="sub in results" :key="sub.id">
                        <td>{{ sub.campaignName }}</td>
                        <td>{{ sub.amount / 100 }} €</td>
                        <td>{{ sub.nextPaymentDate | formatDateFromISO }}</td>
                        <td>
                            <span v-if="sub.isActive">Aktiivinen</span>
                            <span v-else>Inaktiivinen</span>
                        </td>
                        <td>
                            <button 
                                v-if="sub.isActive" 
                                @click="openConfirmationDialog(sub)"
                                class="btn btn-warning"
                            >
                                Peruuta tilaus
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Mobile layout, hidden on desktop -->
            <div class="mobile-view">
                <div v-for="sub in results" :key="sub.id" class="mobile-item">
                    <h5>{{ sub.campaignName }}</h5>
                    <p><strong>Määrä:</strong> {{ sub.amount / 100 }} €</p>
                    <p><strong>Seuraava maksupäivä:</strong> {{ sub.nextPaymentDate | formatDateFromISO }}</p>
                    <p>
                        <strong>Status:</strong>
                        <span v-if="sub.isActive">Aktiivinen</span>
                        <span v-else>Inaktiivinen</span>
                    </p>
                    <button 
                        v-if="sub.isActive" 
                        @click="openConfirmationDialog(sub)"
                        class="btn btn-warning btn-sm"
                    >
                        Peruuta tilaus
                    </button>
                </div>
            </div>
        </div>

        <div v-if="loading" id="loader" class="spinner" />

        <confirmation-dialog 
        v-if="isDialogVisible"
        :visible="isDialogVisible"
        title="Vahvista tilauksen peruutus"
        :selectedSub="selectedSubscription.campaignName"
        message="Haluatko varmasti peruuttaa tilauksen?"
        @confirm="confirmSetInactive"
        @cancel="closeConfirmationDialog"/>
    </div>
</template>



<script>
    import {views} from "../../mixins/ViewMixin"
    import {timeMixin} from "../../mixins/TimeMixin"
    import ConfirmationDialog from "./ConfirmationDialog.vue";
    import Axios from 'axios';

    export default {
        name: "my-subscriptions",
        mixins: [views, timeMixin],
        components: {ConfirmationDialog},
        selectedSubscription: null,
        filters: {
            formatDateFromISO(isoDate) {
                const date = new Date(isoDate);
                return date.toLocaleDateString('fi-FI');
            }
        },
        data() {
            return {
                views,
                activeTab: 1,
                selectedSub: null,
                loading: false,
                results: [],
                isDialogVisible: false,
                cancelToken: null

            }
        },

        mounted() {
        this.fetchSubscriptions();
        },
    
        methods: {
            fetchSubscriptions() {
                this.loading = true;
                this.results = [];

                Axios.get(`${process.env.VUE_APP_FAIR_API}verifonepayment/subscriptions`)
                    .then(response => {
                        this.results = response.data || [];
                    })
                    .catch(error => console.error(error))
                    .finally(() => this.loading = false);
            },
            setInactive(sub) {
                console.log("todo set inactive", sub)
            },

            openConfirmationDialog(sub) {
                this.selectedSubscription = sub;
                this.isDialogVisible = true;
            },
            closeConfirmationDialog() {
                this.cancelToken.cancel();
                console.log("cancelled");
                this.isDialogVisible = false;
                this.selectedSubscription = null;
            },
            confirmSetInactive() {
              if(this.cancelToken) {
                this.cancelToken.cancel();
              }
              this.cancelToken = Axios.CancelToken.source();
                if (this.selectedSubscription) {
                    this.loading = true;
                    // use cancel token
                    Axios.post(`${process.env.VUE_APP_FAIR_API}verifonepayment/${this.selectedSubscription.id}/deactivate`, {
                        isActive: false,
                    }, { cancelToken: this.cancelToken.token })
                    .then(response => {
                        console.log("Subscription deactivated", response);
                        this.setInactive(this.selectedSubscription);
                        this.fetchSubscriptions();
                    })
                    .catch(error => {
                        console.error("Failed to deactivate subscription", error);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.closeConfirmationDialog();
                    });
                } else {
                    this.closeConfirmationDialog();
                }
            },
    },

            success: function (response) {
                this.loading = false
                this.results = response
            },

            fail: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            showSubscription(sub) {
                this.selectedSub = sub;
            },

            closeAndUpdateSubscription: function () {
                this.selectedSub = null
                this.fetchSubscriptions()
            },

            closeSubscription() {
                this.selectedSub = null
            },

            showAlert(message) {
                this.$emit('alert', message)
            }
        }
</script>

<style scoped>
</style>
